<template>
  <div class="page home">
    <div class="page-header">
      <button class="header-nav-btn" @click="$parent.$refs.nav.open()" aria-label="Open nav menu"></button>

      <span class="page-title">FAQs</span>
      <HeaderNav />
    </div>

    <div class="page-content" v-if="'id' in pageData">
      <Components :components="pageData.acf.components" location="above" />

      <div class="page-container">
        <h1>Frequently Asked Questions</h1>

        <ul class="faq-list">
          <li v-for="faq in pageData.acf.faq" :key="faq.question">
            <button class="question" :class="faq.isOpen ? 'open' : ''" @click="toggleFaq(faq)">{{faq.question}}</button>

            <collapse-transition>
              <div class="answer wysiwyg" v-show="faq.isOpen" v-html="faq.answer"></div>
            </collapse-transition>
          </li>
        </ul>
      </div>

      <Components :components="pageData.acf.components" location="below" />
      <Footer />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import SubPageUtils from '../mixins/SubPageUtils';

import Components from '../components/Components';
import HeaderNav from '../components/HeaderNav';
import Footer from '../components/Footer';

import { CollapseTransition } from "@ivanv/vue-collapse-transition"

export default {
  name: 'FAQ',
  components: { Components, HeaderNav, Footer, CollapseTransition },
  mixins: [SubPageUtils],
  data() {
    return {
      pageData: {},
    }
  },
  methods: {
    toggleFaq(faq) {
      if ('isOpen' in faq) {
        return faq.isOpen = !faq.isOpen;
      }

      Vue.set(faq, 'isOpen', true)
    }
  },
  async mounted() {
    const pageDataResponse = await fetch(`https://admin.austinstudiotour.org/wp-json/wp/v2/pages/19091`)
    this.pageData = await pageDataResponse.json();
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

.page-container {
  padding: 50px 20px;
}

h1 {
  margin-bottom: 20px;
  text-align: center;
}

.faq-list {
  li {
    margin-bottom: 80px;
  }
  .question {
    margin-bottom: 10px;
    font-family: @fontPrimary;
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    line-height: 25px;
    color: #000;
    &.open::before {
      transform: translateY(3px) rotate(135deg);
    }
    &::before {
      content: '+';
      display: inline-block;
      width: 30px;
      height: 30px;
      min-height: 30px;
      min-width: 30px;
      margin-right: 15px;
      transform: translateY(3px);
      transition: transform 500ms;
      font-family: @fontSecondary;
      font-size: 29px;
      font-weight: normal;
      line-height: 30px;
      text-align: center;
      color: #fff;
      border-radius: 20px;
      background-color: #000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FAQ.vue